/**
 * Anzeigehelfer. Alle Zeiten kommen in UTC vom Server und werden hier — und
 * nur hier — nach Europe/Berlin gedreht.
 */

const ZONE = 'Europe/Berlin'

const datumZeit = new Intl.DateTimeFormat('de-DE', {
  timeZone: ZONE,
  weekday: 'short',
  day: '2-digit',
  month: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
})

const nurZeit = new Intl.DateTimeFormat('de-DE', {
  timeZone: ZONE,
  hour: '2-digit',
  minute: '2-digit',
})

const nurDatum = new Intl.DateTimeFormat('de-DE', {
  timeZone: ZONE,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
})

export function formatDatumZeit(iso: string | number | Date): string {
  return `${datumZeit.format(new Date(iso))} Uhr`
}

export function formatZeit(iso: string | number | Date): string {
  return `${nurZeit.format(new Date(iso))} Uhr`
}

export function formatDatum(iso: string | number | Date): string {
  return nurDatum.format(new Date(iso))
}

function zahl(wert: number): string {
  return Number.isInteger(wert) ? String(wert) : String(wert).replace('.', ',')
}

/** "2 Schnäpse (4 cl)" — Einheiten immer mit Zentilitern, wie die Spec es will. */
export function formatSchnaepse(units: number, unitCl = 2): string {
  const cl = Math.round(units * unitCl * 10) / 10
  const wort = units === 1 ? 'Schnaps' : 'Schnäpse'
  return `${zahl(units)} ${wort} (${zahl(cl)} cl)`
}

/** "2 Einheiten", mit Numerus. */
export function formatEinheiten(units: number): string {
  return `${zahl(units)} ${units === 1 ? 'Einheit' : 'Einheiten'}`
}

/** Restzeit als "2 Tage 3 Std." bzw. "14:03 min". */
export function formatRestzeit(bisMs: number, abMs = Date.now()): string {
  const rest = Math.max(0, bisMs - abMs)
  const sekunden = Math.floor(rest / 1000)
  const minuten = Math.floor(sekunden / 60)
  const stunden = Math.floor(minuten / 60)
  const tage = Math.floor(stunden / 24)

  if (tage > 0) return `${tage} ${tage === 1 ? 'Tag' : 'Tage'} ${stunden % 24} Std.`
  if (stunden > 0) return `${stunden} Std. ${minuten % 60} min`
  return `${String(minuten).padStart(2, '0')}:${String(sekunden % 60).padStart(2, '0')} min`
}
